import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Field, propTypes as reduxFormPropTypes } from 'redux-form';
import { connect } from 'react-redux';
import { Button, Row, Col } from 'reactstrap';

import { fetchLocationData } from 'redux-modules/location';
import { TextFormGroup, SelectFormGroup, validators as V } from 'components/Forms';
import reduxFormWithGeneratorNeedsConfig from './withReduxFormGeneratorNeedsConfig';

const AboutHome = ({ handleSubmit, onSubmit, valid, fetchLocation }) => (
  <form onSubmit={handleSubmit((data) => { fetchLocation(data['Zip Code']); onSubmit(data); })}>
    <div>
      <Row>
        <Col sm={6} xs={12}>
          <Field
            component={TextFormGroup}
            placeholder="1. What is your zip/postal code?"
            name="Zip Code"
            type="text"
            validate={[V.required, V.postalCode]}
          />
        </Col>
        <Col sm={6} xs={12}>
          <Field
            component={SelectFormGroup}
            placeholder="2. How big is your home?"
            name="Square Footage"
            options={[
              { label: 'Under 1,400 sq. ft.', value: '1400' },
              { label: '1,400 - 1,799 sq. ft.', value: '1799' },
              { label: '1,800 - 2,399 sq. ft.', value: '2399' },
              { label: '2,400 - 2,999 sq. ft.', value: '2999' },
              { label: '3,000 - 3,999 sq. ft.', value: '3999' },
              { label: '4,000+ sq. ft.', value: '4000' },
            ]}
            validate={[V.required]}
          />
        </Col>
      </Row>
    </div>
    <div className="footer-button">
      <Button
        disabled={!valid}
        type="submit"
        color="primary"
      >
        Next
      </Button>
    </div>
  </form>
);

AboutHome.propTypes = {
  ...reduxFormPropTypes,
  onSubmit: PropTypes.func.isRequired,
};

const enhance = compose(
  reduxFormWithGeneratorNeedsConfig,
  connect(
    null,
    dispatch => ({
      fetchLocation: zipCode => zipCode && dispatch(fetchLocationData(zipCode)),
    }),
  ),
);

export default enhance(AboutHome);



// WEBPACK FOOTER //
// ./src/views/Home/components/AboutHome.js